import { readVehicle } from '@theme/tt-vehicle-finder';
import { parseList, verdictFor } from '@theme/tt-fitment-verdict';

/**
 * The fitment verdict on a product page.
 *
 * Three states, matching the prototype: confirmed, does-not-fit, and
 * unknown. Rendered on the client because the verdict depends on the
 * vehicle in localStorage, and Shopify's full-page cache would otherwise
 * serve one shopper's verdict to everyone.
 *
 * The default markup in the element is the unknown state, so a shopper with
 * JS disabled still sees what the kit fits — never a blank space where a
 * fitment claim should be.
 */
class FitmentCheck extends HTMLElement {
  connectedCallback() {
    const vehicle = readVehicle();
    if (!vehicle) return;

    const verdict = this.#verdict(vehicle);
    if (verdict === 'unknown') return;

    const label = [vehicle.make, vehicle.model, vehicle.year || null].filter(Boolean).join(' ');
    const template = this.querySelector(`template[data-state="${verdict}"]`);
    if (!template) return;

    const node = template.content.cloneNode(true);
    for (const slot of node.querySelectorAll('[data-vehicle]')) slot.textContent = label;

    this.replaceChildren(node);
  }

  /**
   * @param {{make: string, model: string, year: number}} vehicle
   * @returns {'yes' | 'no' | 'unknown'}
   */
  #verdict(vehicle) {
    return verdictFor(vehicle, {
      makes: parseList(this.dataset.makes),
      models: parseList(this.dataset.models),
      years: parseList(this.dataset.years),
    });
  }
}

if (!customElements.get('tt-fitment-check')) {
  customElements.define('tt-fitment-check', FitmentCheck);
}
